import {getCloudinaryPrefix} from 'libs/cloudinary/cloudinary';
import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';

export type ResponseDataType =
    | {
          error: true;
          message: string;
      }
    | {
          content: string;
          title: string;
          error: false;
      };

export const contentPage = {
    getContent: async (pageId: string | number): Promise<ResponseDataType> => {
        const ANY_ERROR = 'Something is wrong when downloading content for privacy policy';

        try {
            const response = await instanceGusaBackend.get(
                `${ENDPOINTS.CMS_GET_PAGE}/${pageId}?url_prefix=${getCloudinaryPrefix()}`,
            );

            return {
                content: response.data.content,
                title: response.data.title,
                error: false,
            };
        } catch (error) {
            return {
                error: true,
                message: ANY_ERROR,
            };
        }
    },
};
